<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.login-page {
  .login-bg {
    background: linear-gradient(to bottom, #9938B9 0%,black 99%);
    background-size: cover;
    background-position: center;
    //height: 100vh;
  }
}
</style>

<template>
  <div class="auth-wrapper login-page auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex login-bg">
        <span v-if="isElectron" class="text-white font-weight-bolder pt-2 d-inline-block pointer electron-only" @click="$store.dispatch('backToTerminal')"><i class="fa fa-chevron-left"></i> Back to Terminal</span>
      </b-col>

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-text class="mb-2">
            <img class="full-width mb-4 mx-auto d-block" style="max-width: 220px" height="auto" src="~@/assets/images/logo/logo.svg" alt="logo">

            <h3 class="text-center">Welcome to Purple Visits</h3>
          </b-card-text>

          <b-card-text v-if="hasLoginError" class="mt-2" type="warning" style="color: red">
            {{ tooManyAttempts ? 'You have made too many login requests and are temporarily locked out. Please wait a while before retrying.' :
              'Email or password incorrect, please try again' }}
          </b-card-text>
          <b-card-text v-if="hasInternalError" class="mt-2" type="warning" style="color: red">
            Something went wrong, probably at our end. Please contact your support team
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="email"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="email"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                Sign in
              </b-button>

              <b-button v-if="!isElectron"
                variant="outline-primary"
                block
                :to="{name: 'forgot-password'}"
              >
                Forgot Password?
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {mapState} from 'vuex';
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import { logger } from '@/util/logger';
import OffsiteUsersService from '../../services/OffsiteUsersService';
import ElectronService from '../../services/ElectronService';

export default {
  components: {},
  mixins: [togglePasswordVisibility],
  data() {
    return {
      hasLoginError: false,
      hasInternalError: false,
      isLoggingIn: false,
      password: '',
      email: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      bgImage: require('@/assets/images/pages/login-bg.jpg'),
      required,
      tooManyAttempts: false,
    }
  },
  computed: {
    ...mapState({
      isElectron: state => state.isElectron,
    }),
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.$store.dispatch('auth/clearLocalUser');

          setTimeout(() => {
            this.login();
          });
        }
      })
    },
    login() {
      this.hasLoginError = false;
      this.hasInternalError = false;

      useJwt.login({
        email: this.email.toLowerCase(),
        password: this.password,
      })
        .then(res => {
          useJwt.setToken(res.data.token);

          this.getUser();
        }).catch(error => {
        this.hasLoginError = error.response.status < 500;
        this.hasInternalError = error.response.status >= 500;
        this.tooManyAttempts = error.response.status === 429;
      });
    },
    getUser() {
      OffsiteUsersService.getUser().then(res => {
        const user = res.data;

        // Check the user has correct type
        if (user.type !== 'OffsiteUser') {
          logger.warn('User is not of correct type', null, { user, expectedType: 'OffsiteUser' }, 'Login:getUser');
          // Clear the token and display an error
          this.$store.dispatch('auth/clearLocalUser');
          this.$store.commit('auth/SET_USER', null);
          this.isLoggingIn = false;
          this.hasLoginError = true;
          this.hasInternalError = false;
        } else {
          this.$store.dispatch('auth/setLocalUser', user);
          this.$router.push({ name: 'dashboard' });
        }
      }).catch(err => {
        logger.error('Error getting user', err, { email: this.email }, 'Login:getUser');
        this.isLoggingIn = false;
        this.hasLoginError = err.response.status < 500;
        this.hasInternalError = err.response.status >= 500;
      });
    },
  },
}
</script>
